import vehicleview from "../../views/modules/vehicle_module/vehicleview.vue";
import vehicleV from "../../views/modules/vehicle_module/vehicleM.vue";
import layouts from "../../layout";

export default {
  path: "/vehicleview",
  name: "vehiclemodule",
  component: vehicleV,
  meta: {
    auth: true
  },
  redirect: {
    name: "vehicle-list"
  },
  children: [
    {
      path: "vehiclevirew",
      name: "vehicle-list",
      component: vehicleview,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Vehicle",
        tags: ["vehicle", "view"],
        index: true
      }
    }
  ]
};
